import services from "../services";

const strict = true;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getSiSaluteURL({ commit }, funcType) {
    try {
      commit("loading/openLoadingDialog", null, { root: true });
      return await services.externalService.callGetSiSaluteServiceURL({
        function: funcType
      });
    } catch (error) {
      let errorDetails = {
        ...error
      };
      commit("error/setError", errorDetails, { root: true });
    } finally {
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
    }
  },
  async getUniSaluteURL({ commit }, funcType) {
    try {
      commit("loading/openLoadingDialog", null, { root: true });
      return await services.externalService.callGetUniSaluteServiceURL({
        function: funcType
      });
    } catch (error) {
      let errorDetails = {
        ...error
      };
      commit("error/setError", errorDetails, { root: true });
    } finally {
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
    }
  },
  async getMyFondoEstURL({ commit }, funcType) {
    try {
      commit("loading/openLoadingDialog", null, { root: true });
      return await services.externalService.callGetMyFondoEstServiceURL({
        function: funcType
      });
    } catch (error) {
      let errorDetails = {
        ...error
      };
      commit("error/setError", errorDetails, { root: true });
    } finally {
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
    }
  },
  async getMutualHelpURL({ commit, rootGetters }, funcType) {
    try {
      commit("loading/openLoadingDialog", null, { root: true });
      return await services.externalService.callGetMutualHelpServiceURL({
        memberFiscalCode: rootGetters["login/userInfo"].codiceFiscale,
        function: funcType
      });
    } catch (error) {
      let errorDetails = {
        ...error
      };
      commit("error/setError", errorDetails, { root: true });
    } finally {
      commit("loading/closeLoadingDialog", null, {
        root: true
      });
    }
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
